<!--
 * @Author: RYL
 * @Description: 处理报警
 * @Date: 2020-12-29 18:26:27
 * @LastEditTime: 2020-12-30 09:29:22
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.alarmList.Handlingalarms')"
      :visible.sync="dialogVisible"
      center
    >
      <div class="handle-form">
        <el-form :model="formData" ref="handleForm" label-width="100px">
          <el-form-item :label="$t('lang.alarmList.ProcessDescription')">
            <el-input
              class="form-input"
              size="mini"
              type="textarea"
              :rows="2"
              v-model="formData.description"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.Button.cancel")
        }}</el-button>
        <el-button size="mini" type="primary" @click="save">{{
          $t("lang.Button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { handleAlarm } from "@/api/cloudMonitor/alarmList";
export default {
  data() {
    return {
      formData: {
        id: "",
        description: "",
      },
      dialogVisible: false,
    };
  },
  methods: {
    show(item) {
      console.log("itme");
      console.log(item);
      this.dialogVisible = true;
      this.formData.description = "";
      this.formData.id = item.id;
    },
    save() {
      handleAlarm(this.formData)
        .then((res) => {
          if (res.data.code === 0) {
            this.$emit("queryKeyword");
            // this.getAlarmList()
            this.$message.success(this.$t("lang.alarmList.msg1"));
            this.description = "";
            this.dialogVisible = false;
          } else {
            this.$message.error(this.$t("lang.alarmList.msg2"));
          }
        })
        .catch(() => {
          this.$message.error(this.$t("lang.alarmList.msg3"));
        });
    },
  },
};
</script>
<style scoped>
.handle-form {
  display: flex;
  justify-content: center;
}
.form-input {
  width: 4rem;
}
</style>
